import { useCollectionsStateContext } from '../../components/CollectionStateProvider';

/**
 * @returns {function(string, boolean): void}
 */
export const useSetCollectionOpen = () => useCollectionsStateContext().setOpen;
